$(document).ready(function () {
    let options = {
        types: ['geocode'],
        // componentRestrictions: { country: 'nz' }
    };
    let inputs  = document.getElementsByClassName('google-autocomplete');
    for (let i = 0; i < inputs.length; i++) {
        let autocomplete = new google.maps.places.Autocomplete(inputs[i], options);
        if (window.googleAutocompleteCountries) {
            autocomplete.setComponentRestrictions({'country': window.googleAutocompleteCountries});
        }
    }
});



// WEBPACK FOOTER //
// ./modules/Core/Assets/js/google-autocomplete.js